import { render, staticRenderFns } from "./DepositHistory.vue?vue&type=template&id=b8c464ac"
import script from "./DepositHistory.vue?vue&type=script&lang=js"
export * from "./DepositHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports